import React, { useState } from 'react'

import s from './CollectionsFooter.module.css'
import CreatePopup from './components/CreatePopup/CreatePopup'

function CollectionsFooter({ fetchCollections }) {
  const [showCreatePopup, setShowCreatePopup] = useState(false)

  return (
    <>
      <div className={s.root}>
        <button type="button" className={s.button} onClick={() => setShowCreatePopup(true)}>
          Create new collection
        </button>
      </div>

      {showCreatePopup && <CreatePopup fetchCollections={fetchCollections} onClose={() => setShowCreatePopup(false)} />}
    </>
  )
}

export default CollectionsFooter
